<script type="text/javascript">
	import moment from "moment";
	import { get } from "svelte/store";
	import AuthStore from "../../Auth/Store";
	import LoadState from "../../Enums/LoadState";
	import GeoHelper from "../../Helpers/GeoHelper";
	import StringHelper from "../../Helpers/StringHelper";
	import MapStore from "../../Map/Store";
	import ModalWindow from "../../UI/ModalWindow.svelte";
	import Spinner from "../Spinner/Spinner.svelte";
	import SpinnerSize from "../Spinner/SpinnerSize";
	import RiskIntStore from "./IncidentsStore";

	let loadState = RiskIntStore.meta.loadState;
	let loaded = false;
	$: {
		loaded = $loadState === LoadState.LOADED;
	}

	let visible = RiskIntStore.meta.visible;
	RiskIntStore.meta.visible.subscribe((visible) => {
		if (visible
			// User.hasFeature(Feature.TODO)
			) {
                RiskIntStore.actions.initMap( MapStore.helpers.getMap() );
                RiskIntStore.actions.init( MapStore.helpers.getMap() );
		}
        else {
            RiskIntStore.actions.deinitMap();
        }
	});

	let incidents = RiskIntStore.results.incidents;
	let lastUpdated = RiskIntStore.meta.lastUpdated;
	$: {
		$visible;
        if (!$visible) {
            $incidentVisible = false;
            $currentIncident = null;
        }
		$lastUpdated;
		RiskIntStore.actions.updateFeatureCollection();
		// RiskIntStore.actions.updateVisibility();
	}

	$: {
		$lastUpdated;
		$incidents = $incidents;
	}


    let dateFormat = "Do MMMM YYYY";

    let incidentVisible = RiskIntStore.meta.incidentVisible;
	let currentIncident = RiskIntStore.meta.selectedIncident;

    let windowInstance = null;

</script>

<style type="text/scss">


.ri-incident-box {
	padding:15px;
	border:1px solid #ddd;
	border-radius: 8px;
	margin-bottom: 8px;
	p, h5 {
		margin-top: 2px;
		margin-bottom: 2px;
		line-height: 22px;
	}
    img.icon {
        width:16px;
        height:16px;
        margin-top:3px;
        margin-bottom:3px;
        margin-right:6px;
    }
}
.ri-incident-modal-content {
    h5 {
		margin-top: 2px;
		margin-bottom: 2px;
		line-height: 22px;
	}
    p {
        line-height:22px;
    }
    img.icon {
        width:16px;
        height:16px;
        margin-top:3px;
        margin-bottom:3px;
        margin-right:6px;
    }
}

</style>


<ModalWindow
    title={`Risk Intelligence - Incidents`}
    hasCloseButton={true}
    hasBackground={false}
    resizable={true}
    draggable={true}
    fullscreen={false}
    padding={true}
    position="top-right"
    height="70%"
    bind:this={windowInstance}
    bind:open={$visible}>

    {#if $loadState === LoadState.LOADING}
        <div class="spinner-center">
            <Spinner size={SpinnerSize.SMALL} absolute={false} inline={true} />
        </div>
    {/if}
    {#if $loadState === LoadState.LOADED}

		<!-- <Textfield
			dense
			variant="filled"
			label={"Filter by Port Name..."}
			bind:value={$rawFilterString}
			style="width:100%;"
			/> -->

		<!-- <div class="port-assessments-table-container mdc-elevation--z2" > -->

            {#each $incidents as incident (incident.id)}
                <!-- {#if ($rawFilterString.trim().length === 0 ||
                    feature.attributes.Name.toLowerCase().indexOf($rawFilterString.toLowerCase()) >= 0)} -->
                    <div class='ri-incident-box oa'>
                        <p class='text-muted'><img class='fl icon' src={RiskIntStore.helpers.getIconSrcForIncidentTypeId(incident.type.id)} alt={incident.type.description} /> {moment(incident.date).format(dateFormat)} - {incident.region.name}</p>
                        <!-- {#if incident.area !== null}{({incident.area.name}){/if} -->
                        <h5>{incident.title}</h5>
                        <p class='text-muted'>{@html incident.teaser}</p>
                        <button class='btn btn-sm fl bg-primary mr-3' on:click={()=>{
                            RiskIntStore.actions.openIncident(incident.id);
                        }}>Open</button>
                        <button class='btn btn-sm fl bg-secondary' on:click={()=>{
                            MapStore.helpers.zoomToPoint([incident.markerPosition.longitude, incident.markerPosition.latitude]);
                        }}>Go to</button>
                        <!-- <td>{feature.attributes.ThreatLevel}</td>
                        <td>{moment.utc(feature.attributes.AssessmentDate).format("MMM Do YYYY")}</td>
                        <td>
                            <button class='btn btn-sml bg-info' on:click={()=>{
                                Analytics.event("open_assessment_" + feature.attributes.Name, { category: "Ports", username: get(AuthStore.userInfo).username, portName: feature.attributes.Name });
                                window.open(feature.attributes.PortAssessmentURL);
                            }}>Open</button>
                            <button class='btn btn-sml bg-info' on:click={()=>{
                                MapStore.helpers.zoomToPoint([feature.geometry.x, feature.geometry.y]);
                            }}>Find</button>
                        </td> -->
                    </div>
                <!-- {/if} -->
            {/each}

		<!-- </div> -->
    {/if}
</ModalWindow>

{#if $visible && $incidentVisible && $currentIncident !== null}
    <ModalWindow
        title={`Incident`}
        hasCloseButton={true}
        hasBackground={false}
        resizable={true}
        draggable={true}
        fullscreen={false}
        padding={true}
        position="top-right"
        height="70%"
        bind:open={$incidentVisible}
        parent={windowInstance}
        >
        <div class='ri-incident-modal-content oa'>
            <h5><img class='fl icon' src={RiskIntStore.helpers.getIconSrcForIncidentTypeId($currentIncident.type.id)} alt={$currentIncident.type.description} /> {$currentIncident.title}</h5>
            <div class='oa' style="margin-bottom:14px;">
                <h5 class='text-muted fl'>{$currentIncident.type.description}</h5>
                <h5 class='text-muted fr'>{moment($currentIncident.date).format(dateFormat)}</h5>
            </div>
            <div>
                {#if $currentIncident.images.length > 0}
                    {#each $currentIncident.images as image}
                        <img src={image.url} alt="Incident image" style="width:100%;"/>
                    {/each}
                {/if}
                <!-- images -->
            </div>
            <!-- <p class='text-muted'>{$currentIncident.type.description} {moment($currentIncident.date).format(dateFormat)} </p> -->
            <p>
                <b>Region:</b> {$currentIncident.region.name}
                {#if $currentIncident.area}
                    <br/><b>Area:</b> {$currentIncident.area.name}
                {/if}
                {#if $currentIncident.entity !== null}
                    {#if $currentIncident.entity.type.id === "port"}
                        <br/><b>Port:</b> {$currentIncident.entity.name}
                    {/if}
                    {#if $currentIncident.entity.type.id === "country"}
                        <br/><b>Country:</b> {$currentIncident.entity.name}
                    {/if}
                {/if}
            </p>

            <p><b>{@html $currentIncident.teaser}</b></p>
            <p>{@html StringHelper.nl2br($currentIncident.description)}</p>

            <p>
                {#if $currentIncident.imo && typeof $currentIncident.imo !== "object"}
                    <br/><b>IMO:</b> {$currentIncident.imo}
                {/if}
                {#if $currentIncident.callSign && typeof $currentIncident.callSign !== "object"}
                    <br/><b>Call Sign:</b> {$currentIncident.callSign}
                {/if}
            </p>
            <p>
                <b>Marker Position:</b> {GeoHelper.lngLatCoordinatesToString([$currentIncident.markerPosition.longitude, $currentIncident.markerPosition.latitude], get(AuthStore.session.user).lngLatFormat, 4)}
                <button class='btn btn-sm bg-secondary' style='margin-left:5px;font-size:12px;padding-top:3px;' on:click={()=>{
                    MapStore.helpers.zoomToPoint([$currentIncident.markerPosition.longitude, $currentIncident.markerPosition.latitude]);
                }}>Go to</button>
            </p>

        </div>
    </ModalWindow>
{/if}